<template>
    <div class="banner-suscribe">
        <div class="logo"></div>
        <div class="text">{{$t('home2021.banners.suscribe.contents')}} <span>{{$t('home2021.banners.suscribe.xxx')}}</span>
        </div>
        <div class="access">
            <router-link
                class="btn-action"
                :to="{name: 'category.index'}"
            >
                {{$t('home2021.banners.suscribe.get_access')}}
            </router-link>
        </div>
    </div>
</template>
<script>
import resources from "../../resources";

export default {
    name: 'BannerSuscribe',
    methods: {},
    computed:{},
}
</script>
<style scoped lang="scss">
@import '../../styles/variables';

section {
    text-align: left;
}

.banner-suscribe{
    display: flex;
    justify-content: center;
    align-items: center;
    background: #2f2e2e;
    height: 60px;
    border-radius: 50px;
    margin: 40px auto;
    width: max-content;
    padding: 0 100px;
    @media(max-width: 960px){
        flex-direction: column;
        padding: 10px 0;
        width: 90%;
        height: unset;
        border-radius: 30px;
        margin: 20px auto;
    }
    .logo{
        width: 332px;
        height: 53px;
        background-image: url("/img/logo-white.png");
        background-size: 80%;
        background-repeat: no-repeat;
        background-position: center right;
        margin-top: 5px;
        @media(max-width: 960px){
            //background-size: contain;
            //background-repeat: no-repeat;
            background-position: center;
            width: 85%;
            height: 50px;
        }
    }
    .text{
        color: #ffffff;
        font-size: 2em;
        font-family: "Arial Narrow";
        font-weight: bold;
        transform: scaleY(1.5);
        margin: 0 20px;
        @media(max-width: 960px){
            margin: 5px auto 20px auto;
            font-size: 1.4em;
        }
        span{
            color: #ff0000;
        }
    }
    .access{
        line-height: 2;
        width: 150px;
        border: 2px solid #ff0000;
        border-radius: 10px;
        text-align: center;
        color: #ff0000;
        text-transform: uppercase;
        font-size: 1.2em;
        transition: 200ms;
        font-weight: bold;
        &:hover{
            background: #ff0000;
            color: #ffffff;
        }
        .btn-action{
            display: block;
            width: 100%;
            height: 100%;
        }
    }
}
</style>